































import {Component, Emit, Prop, Vue, Watch} from 'vue-property-decorator';
import BButton from 'buefy/src/components/button/Button.vue';
import {namespace} from 'vuex-class';
import {CommentQue, FAQ, ReviewRate} from '@/store/RateReviewFaq/types';
import BIcon from 'buefy/src/components/icon/Icon.vue';
import BInput from 'buefy/src/components/input/Input.vue';
import BLoading from 'buefy/src/components/loading/Loading.vue';
import BField from 'buefy/src/components/field/Field.vue';
import {MAFUser} from '@/store/User/types';
import {DateTime} from 'luxon';
import * as firebase from 'firebase/app';
import DocumentReference = firebase.firestore.DocumentReference;

// TODO: fix
/* tslint:disable:no-empty */

const userPath = 'userState';
const userNamespace = namespace(userPath);
const ratePath = 'rateState';
const rateNamespace = namespace(ratePath);
const friendPath = 'friendState';
const friendNamespace = namespace(friendPath);
@Component({
    components: {BIcon, BButton, BInput, BField, BLoading},
})
export default class HelpBody extends Vue {
    @rateNamespace.State('faqs') public faqs!: FAQ[];
    @rateNamespace.Action('addComment') public addComment!: any;
    @userNamespace.State('selfRef') public selfRef!: DocumentReference;
    public isLoading: boolean = false;
    public comment: string = '';
    public showError: boolean = false;
    public showSuccess: boolean = false;
    constructor() {
        super();
    }

    public async submit() {
        if (!this.comment) {
            this.showError = true;
            this.showSuccess = false;
            return;
        }
        this.showError = false;
        this.showSuccess = false;
        this.isLoading = true;
        const commentObj = new CommentQue(null);
        commentObj.comment = this.comment;
        commentObj.date = DateTime.local().toJSDate();
        commentObj.userRef = this.selfRef;
        await this.addComment(commentObj.toPlainObj());
        this.comment = '';
        this.isLoading = false;
        this.showSuccess = true;
    }
    @Emit('close')
    public close() {
    }
}
